<template>
    <div class="shop_areas">
        <Header2 :searchShow="false" pageTitle="专卖店查询"></Header2>
        <div class="sas_con">
            <div class="hd_search">
                <div class="se_box flex1">
                    <input type="text" v-model="keyword" placeholder="全国专卖店查询" />
                    <img @click="searchBtn" src="@/images/zoom2.png" />
                </div>
            </div>
            <div class="sp_head2 flex1">
                <div class="aph_d1 flex3">
                    <span class="slt_tit">省份：</span>
                    <select class="slt_box" @change="handlProChange">
                        <option value="">不限</option>
                        <option
                            :value="item.storeProvinceCode"
                            v-for="item in proList"
                            :key="item.id"
                        >
                            {{ item.storeProvinceName }}
                        </option>
                    </select>
                    <img class="dp1_right" src="@/images/right1.png" />
                </div>
                <div class="aph_d1 flex3">
                    <span class="slt_tit">城市：</span>
                    <select class="slt_box" @change="handlCityChange">
                        <option value="">不限</option>
                        <option
                            :value="item.storeCityCode"
                            v-for="item in cityList"
                            :key="item.id"
                        >
                            {{ item.storeCityName }}
                        </option>
                    </select>
                    <img class="dp1_right" src="@/images/right1.png" />
                </div>
            </div>
            <ul class="sf_ul">
                <li
                    class="sf_li"
                    :id="item.szm"
                    v-for="item in proList2"
                    :key="item.id"
                >
                    <p class="sf_li_zm">{{ item.szm }}</p>
                    <div class="sf_li_dd">
                        <p
                            v-for="item2 in item.storeProvinceName"
                            :key="item2.id"
                            @click="chooseCity(item)"
                        >
                            {{ item2.storeProvinceName }}
                        </p>
                    </div>
                </li>
            </ul>
            <div class="zm_box">
                <span
                    @click="selZiMu(item)"
                    :class="zmCurt == item ? 'zmact' : ''"
                    v-for="item in zmarr"
                    :key="item"
                    >{{ item }}</span
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            proList: [], //下拉显示的省份
            proList2: [], //包含字母的省份
            proCode: "",
            cityList: [],
            cityCode: "",
            zmarr: [],
            zmCurt: "",
            keyword: "",
        };
    },
    created() {
        this.phonesheng();
    },
    methods: {
        async phonesheng() {
            const res = await this.$api.phonesheng();
            if (res.code == 1) {
                this.proList2 = res.data;
                for (let i = 0; i < this.proList2.length; i++) {
                    this.proList = this.proList.concat(
                        this.proList2[i].storeProvinceName
                    );
                    this.zmarr.push(this.proList2[i].szm);
                }
            }
        },
        async phoneshi(a) {
            const res = await this.$api.phoneshi({
                storeProvinceCode: a,
            });
            if (res.code == 1) {
                if (res.data.length) {
                    this.cityList = res.data;
                } else {
                    this.cityList = [];
                }
            }
        },
        handlProChange(e) {
            this.proCode = e.target.value;
            this.phoneshi(this.proCode);
        },
        handlCityChange(e) {
            this.cityCode = e.target.value;
        },
        selZiMu(a) {
            this.zmCurt = a;
            const element = document.getElementById(a);
            if (element) {
                element.scrollIntoView({
                    block: "start",
                    behavior: "smooth",
                });
            }
        },
        chooseCity(item){
            this.$router.push("/shopList?procode="+item.storeProvinceCode);
        },
        searchBtn(){
            this.$router.push("/shopList?procode="+this.proCode+'&citycode='+this.cityCode+'&keyword='+this.keyword);
        }
    },
};
</script>

<style lang="scss">
.zmact {
    background-color: #d43235 !important;
    color: #fff !important;
}
.shop_areas {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
    padding: 1.23rem 0 2.4rem 0;
    min-height: 90vh;
    background-image: url("../../images/bgimg3.png");
    .sas_con {
        .hd_search {
            padding: 0.4rem 0.53rem 0.47rem;
            .se_box {
                background-color: #fff;
                position: relative;
                height: 1.17rem;
                padding: 0 0.33rem;
                border-radius: 1.17rem;
                display: flex;
                justify-content: space-between;
                input {
                    color: #666;
                    font-size: 17px;
                    width: 100%;
                    height: 1.17rem;
                    border-radius: 1.17rem;
                    background-color: #fff;
                    border: none;
                    outline: none;
                }
                img {
                    width: 0.45rem;
                }
            }
        }
        .sp_head2 {
            padding: 0 0.53rem;
            margin-bottom: 0.5rem;
            box-sizing: border-box;
            .aph_d1 {
                width: 50%;
                padding-right: 0.48rem;
                span {
                    font-size: 17px;
                    color: #666;
                }
                .slt_box {
                    color: #333;
                    font-size: 17px;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    appearance: none;
                    background: transparent;
                    width: 40%;
                    border: none;
                    margin-bottom: 1px;
                    outline: none;
                    flex: 1;
                }
                .dp1_right {
                    width: 8px;
                    margin-left: 0.48rem;
                }
            }
        }
        .sf_ul {
            .sf_li {
                .sf_li_zm {
                    color: #999;
                    font-size: 12px;
                    background-color: #dfdfdf;
                    padding: 0.37rem 1.57rem 0.37rem 0.53rem;
                    font-weight: 700;
                    text-align: left;
                }
                .sf_li_dd {
                    p {
                        color: #333;
                        font-size: 17px;
                        padding: 0.37rem 1.57rem 0.37rem 0.53rem;
                        border-bottom: 1px solid #dddcdd;
                        text-align: left;
                    }
                }
            }
        }
        .zm_box {
            position: fixed;
            right: 0.32rem;
            top: 50%;
            transform: translateY(-50%);
            z-index: 999;
            max-height: 62%;
            overflow: auto;
            span {
                display: block;
                width: 0.69rem;
                height: 0.69rem;
                border-radius: 50%;
                text-align: center;
                line-height: 0.69rem;
                color: #333;
                font-size: 15px;
            }
        }
    }
}
</style>